"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import type { JobComponent } from "@repo/design-system/lib/client-registry";
import { cn } from "@repo/design-system/utils/cn";
import { useMemo } from "react";
import { useLanguage } from "~/translations/loader/use-language";
interface Step {
  className?: string;
  icon: string;
  text: string;
  title: string;
}
function Card(t0) {
  const $ = _c(13);
  const {
    title,
    text,
    icon,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative flex flex-col gap-y-4 bg-[#f59a86] p-6 md:p-8 lg:p-10", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon) {
    t2 = <div className="flex h-16 items-center"><CustomImage alt="" className="max-h-14" height={80} src={icon} width={40} /></div>;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <h3 className="mt-2 mb-4 font-bold text-2xl" data-source="lc">{title}</h3>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== text) {
    t4 = <div className="flex-grow md:text-lg lg:text-xl [&_a]:font-bold [&_p]:mt-4 [&_p]:text-sm" dangerouslySetInnerHTML={{
      __html: text
    }} data-source="lc" />;
    $[6] = text;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <li className={t1}>{t2}{t3}{t4}</li>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
const ApplicationProcessIntGraduate: JobComponent = () => {
  const $ = _c(31);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.intGraduate_process_text1 || $[1] !== t.intGraduate_process_title1) {
    t0 = {
      title: t.intGraduate_process_title1,
      text: t.intGraduate_process_text1,
      icon: "images/icons/trainee/manage_online.svg"
    };
    $[0] = t.intGraduate_process_text1;
    $[1] = t.intGraduate_process_title1;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.intGraduate_process_text2 || $[4] !== t.intGraduate_process_title2) {
    t1 = {
      title: t.intGraduate_process_title2,
      text: t.intGraduate_process_text2,
      icon: "images/icons/trainee/document.svg"
    };
    $[3] = t.intGraduate_process_text2;
    $[4] = t.intGraduate_process_title2;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t.intGraduate_process_text3 || $[7] !== t.intGraduate_process_title3) {
    t2 = {
      title: t.intGraduate_process_title3,
      text: t.intGraduate_process_text3,
      icon: "images/icons/trainee/quattiers_app.svg"
    };
    $[6] = t.intGraduate_process_text3;
    $[7] = t.intGraduate_process_title3;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t.intGraduate_process_text4 || $[10] !== t.intGraduate_process_title4) {
    t3 = {
      title: t.intGraduate_process_title4,
      text: t.intGraduate_process_text4,
      icon: "images/icons/trainee/date.svg"
    };
    $[9] = t.intGraduate_process_text4;
    $[10] = t.intGraduate_process_title4;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t.intGraduate_process_text5 || $[13] !== t.intGraduate_process_title5) {
    t4 = {
      title: t.intGraduate_process_title5,
      text: t.intGraduate_process_text5,
      icon: "images/icons/trainee/contract.svg"
    };
    $[12] = t.intGraduate_process_text5;
    $[13] = t.intGraduate_process_title5;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t0 || $[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = [t0, t1, t2, t3, t4];
    $[15] = t0;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const steps = t5;
  let t6;
  if ($[21] !== t.jobad_process_hl) {
    t6 = <h2 className="mb-8 font-bold text-3xl md:mb-12 md:text-4xl lg:text-5xl" data-source="lc">{t.jobad_process_hl}</h2>;
    $[21] = t.jobad_process_hl;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== steps) {
    t7 = <ul className="grid gap-4 md:grid-cols-6 md:gap-6 lg:gap-10">{steps.map(_temp)}</ul>;
    $[23] = steps;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t.intGraduate_process_bottomNote) {
    t8 = <p className="mt-8 text-right text-sm" data-source="lc">{t.intGraduate_process_bottomNote}</p>;
    $[25] = t.intGraduate_process_bottomNote;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t9 = <section className="outer-container py-container text-foreground print:hidden" id="applicationProcess"><div className="inner-container"><div className="relative mx-auto max-w-screen-xl text-[#262626]">{t6}{t7}{t8}</div></div></section>;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default ApplicationProcessIntGraduate;
function _temp(step, index) {
  return <Card key={step.title} {...step} className={cn("md:col-span-2", index >= 3 && "md:col-span-3")} />;
}